import { useEffect, useState, useRef, FC } from 'react'
import { Drawer, Button, Form, Select, Input } from 'mk-pc'
import './DataScopeSet.scss'

interface Props {
  visible: boolean
  dataScopes?: Array<any>
  nav: any
  onConfirm: (e: any) => void
  onClose?: (refresh?: boolean) => void
}

/**
 * 数据权限维护
 */
export const DataScopeSet: FC<Props> = (props) => {
  const { visible, nav, dataScopes = [], onConfirm, onClose } = props
  const [form] = Form.useForm()
  const defaultFormData = useRef<any>([])
  const [navDataScope, setNavDataScope] = useState<any>([])

  useEffect(() => {
    if (!visible || !nav) return
    setNavDataScope(nav?.dataScopes || [])
    defaultFormData.current = [...(nav?.dataScopes || [])]

    if (Array.isArray(dataScopes)) {
      const _dataScopes = []
      for (const v of dataScopes.filter((ds: any) => ds.resourceId === nav.id)) {
        form.setFieldValue(v.dataCode, v.dataValue)

        _dataScopes.push({
          navId: v.resourceId,
          dataCode: v.dataCode,
          dataName: v.dataName,
          dataType: v.dataType,
          dataValue: v.dataValue,
          priority: v.dataPriority
        })
      }

      defaultFormData.current = _dataScopes
    }
  }, [visible, nav, dataScopes])

  /**
   * 选择选项
   * @param e
   * @param options
   */
  const handleSelectChange = (e: any, item: any, options: Array<any>) => {
    const option = options.find((o: any) => o.code === e)

    const _index = defaultFormData.current.findIndex((c: any) => c.navId === item.navId && c.dataCode === item.dataCode)
    if (_index < 0) {
      defaultFormData.current.push({
        navId: item.navId,
        dataCode: item.dataCode,
        dataName: item.dataName,
        dataType: item.dataType,
        dataValue: option ? option.code : '',
        priority: option ? option.priority : 0
      })
    } else {
      defaultFormData.current[_index] = {
        navId: item.navId,
        dataCode: item.dataCode,
        dataName: item.dataName,
        dataType: item.dataType,
        dataValue: option ? option.code : '',
        priority: option ? option.priority : 0
      }
    }
  }

  /**
   * 提交信息
   */
  const handleSubmit = async () => {
    await form.validateFields()

    if (onConfirm)
      onConfirm({
        resourceId: nav.id,
        dataScopes: defaultFormData.current.map((item: any) => {
          return {
            dataCode: item.dataCode,
            dataType: item.dataType,
            dataName: item.dataName,
            dataValue: item.dataValue,
            dataPriority: item.priority
          }
        })
      })
  }

  return (
    <Drawer title="设置数据权限" width={640} size="small" className="datascope" open={visible} onClose={onClose} closeIcon={false}>
      <div className="datascope-form">
        <Form name="basic" form={form} initialValues={defaultFormData.current} layout="vertical" autoComplete="off">
          <Form.Item label="导航名称" layout="horizontal">
            <Input readOnly value={nav?.name} />
          </Form.Item>
          {navDataScope.map((item: any) => {
            let options = []

            if (item.dataOption) {
              if (typeof item.dataOption === 'string') {
                options = JSON.parse(item.dataOption)
              } else if (Array.isArray(item.dataOption)) {
                options = item.dataOption
              }
            }

            return (
              <Form.Item key={item.id} label={item.dataName} name={item.dataCode}>
                <Select
                  fieldNames={{ label: 'name', value: 'code' }}
                  options={options}
                  placeholder="选择数据权限范围"
                  allowClear
                  onChange={(e: any) => handleSelectChange(e, item, options)}
                />
              </Form.Item>
            )
          })}
        </Form>
      </div>
      <footer className="datascope-footer">
        <Button type="primary" onClick={handleSubmit}>
          提交
        </Button>
        <Button onClick={() => onClose && onClose()}>返回</Button>
      </footer>
    </Drawer>
  )
}
